<div class="row">

  <div class="col-md-4 col-offf  offset-md-4
              col-lg-4 offset-lg-4
              col-xl-4 offset-xl-4">

    <form (ngSubmit)="onSignin(f)" #f="ngForm">

      <div class="form-group">

        <label for="username">Username</label>
        <input id="username"
               name="username"
               ngModel
               required
               class="form-control">
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input
                type="password"
                id="password"
                name="password"
                ngModel
                required
                class="form-control">
      </div>

      <button class="btn btn-primary" type="submit" >Log In</button>
    </form>
  </div>

</div>


<!--<simple-notifications></simple-notifications>-->

